import { render } from "./VendorMarketAccountEditor.vue?vue&type=template&id=4d5404ea"
import script from "./VendorMarketAccountEditor.vue?vue&type=script&lang=js"
export * from "./VendorMarketAccountEditor.vue?vue&type=script&lang=js"

import "./VendorMarketAccountEditor.vue?vue&type=style&index=0&id=4d5404ea&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__